import { render, staticRenderFns } from "./JsaForm.vue?vue&type=template&id=12538458"
import script from "./JsaForm.vue?vue&type=script&lang=js"
export * from "./JsaForm.vue?vue&type=script&lang=js"
import style0 from "./JsaForm.vue?vue&type=style&index=0&id=12538458&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports